// src/app/core/interceptors/loading.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SpinnerService } from '@core/services';
import { SKIP_SPINNER } from '@core/constants';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {

    constructor(private spinner: SpinnerService) {}

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

        if (req.context.get(SKIP_SPINNER)) {

            return next.handle(req); // opt-out
        }

        this.spinner.inc();

        return next.handle(req).pipe(finalize(() => this.spinner.dec()));
    }
}
